// extracted by mini-css-extract-plugin
module.exports = {"container":"Zoom_container__35pFg","button":"Zoom_button__NTjcB","zoomInButton":"Zoom_zoomInButton__2WiE5","zoomOutButton":"Zoom_zoomOutButton__j22LG"};